import { useEffect, useState } from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { useConsultationContext } from '../../context/ConsultationContext';
import { useAppDispatch } from '../../store/store';
import { resetState } from '../../store/slices/sickLeaveAndPrescription';
import WithLoader from '../WithLoader/WithLoader';
import Header from './Header';
import MenuItem from './MenuItem';
import WorkingArea from './WorkingArea';
import LeftPanel from './LeftPanel';
import styles from './ConsultationParentComponent.module.scss';

const ConsultationParentComponent = () => {
  const dispatch = useAppDispatch();
  const { selectedSalesOrder, customerMenu, workOrderStatusId, isReports } =
    useConsultationContext();
  const [isPanelVisible, setIsPanelVisible] = useState(true);
  const [leftPanelDefaultSize, setLeftPanelDefaultSize] = useState(20);
  const togglePanelVisibility = () => setIsPanelVisible(!isPanelVisible);

  useEffect(() => {
    if (workOrderStatusId === 6) {
      setLeftPanelDefaultSize(40);
      setIsPanelVisible(false);
    } else {
      setLeftPanelDefaultSize(20);
      setIsPanelVisible(true);
    }
  }, [workOrderStatusId]);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, []);

  return (
    <WithLoader isLoading={!Boolean(selectedSalesOrder)}>
      <div className={styles.container}>
        <Header />
        <PanelGroup direction="horizontal" onLayout={() => {}}>
          <Panel
            id="left-panel"
            collapsible={true}
            collapsedSize={0}
            className={isReports ? `${styles.panel} ${styles.isReports}` : `${styles.panel}`}
            defaultSize={leftPanelDefaultSize}
            minSize={20}
          >
            <LeftPanel />
          </Panel>

          <PanelResizeHandle style={{ position: 'relative' }}>
            <i className={styles.resizeIcon} />
          </PanelResizeHandle>

          <Panel
            minSize={30}
            className={
              isReports ? `${styles.workingPanel} ${styles.isReports}` : `${styles.workingPanel}`
            }
          >
            <WorkingArea />
          </Panel>

          <PanelResizeHandle style={{ position: 'relative' }}>
            <i
              className={
                isPanelVisible
                  ? `${styles.collapseIcon}`
                  : `${styles.collapseIcon} ${styles.rotate}`
              }
              onClick={togglePanelVisibility}
            />
          </PanelResizeHandle>

          {isPanelVisible ? (
            <Panel
              collapsible={true}
              collapsedSize={0}
              className={isReports ? `${styles.panel} ${styles.isReports}` : `${styles.panel}`}
              defaultSize={30}
              minSize={20}
            >
              {customerMenu.map((item: any) => (
                <MenuItem key={item.value} menuItem={item} />
              ))}
            </Panel>
          ) : (
            <div
              className={isReports ? `${styles.panel} ${styles.isReports}` : `${styles.panel}`}
              style={{ padding: '0px 5px' }}
            ></div>
          )}
        </PanelGroup>
      </div>
    </WithLoader>
  );
};

export default ConsultationParentComponent;
